module.exports = __webpack_public_path__ + "static/media/EasyLabImageStep1.537032e8.png";